<template>
  <ankh-list :showPager="false" :showBtnGroup="false" :showSearchForm="false">
    <template #table="{height}">
      <follow-record :height="height" />
    </template>
  </ankh-list>
</template>

<script>
import FollowRecord from "@/components/user/FollowRecord";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserFollow",
  components: {AnkhList, FollowRecord}
}
</script>

<style scoped>

</style>
